import React, { useState, useEffect } from 'react';
import axios from '../api/axiosConfig';

const VerificarSoatsModal = ({ isOpen, onClose, onVerificacionComplete }) => {
  const [loading, setLoading] = useState(false);
  const [pendingTramites, setPendingTramites] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [verifying, setVerifying] = useState(false);
  const [results, setResults] = useState([]);
  const [error, setError] = useState('');
  const [hasCompleted, setHasCompleted] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setLoading(false);
      setPendingTramites([]);
      setCurrentIndex(0);
      setVerifying(false);
      setResults([]);
      setError('');
      setHasCompleted(false);
      fetchPendingSoats();
    }
  }, [isOpen]);

  const fetchPendingSoats = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/tramites/pending-soat-checks');
      setPendingTramites(res.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Error al obtener trámites pendientes.');
    } finally {
      setLoading(false);
    }
  };

  const startVerification = async () => {
    if (pendingTramites.length === 0) return;
    setVerifying(true);
    setError('');

    let currentResults = [];

    for (let i = 0; i < pendingTramites.length; i++) {
      setCurrentIndex(i + 1);
      const tramite = pendingTramites[i];
      try {
        const res = await axios.post(`/api/tramites/check-single-soat/${tramite.id}`);
        const resultData = res.data;
        if (resultData.updated) {
          currentResults.push({ plate: resultData.plate, tramiteId: tramite.id, success: true });
        }
      } catch (err) {
        console.error('Error al verificar trámite:', tramite.id, err);
      }
      setResults([...currentResults]);
    }

    setVerifying(false);
    setHasCompleted(true);
  };

  const handleClose = () => {
    if (hasCompleted) {
      onVerificacionComplete();
    }
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '500px', width: '100%' }}>
        <button className="btn-close" onClick={handleClose} disabled={verifying}>
          &times;
        </button>
        <div className="modal-header">
          <h3>🛡️ Verificar SOATs Automáticos</h3>
        </div>
        
        <div className="modal-body" style={{ textAlign: 'center' }}>
          {error && <div className="error-banner">{error}</div>}

          {loading ? (
            <p>⏳ Obteniendo lista de trámites pendientes...</p>
          ) : (
            <>
              {!verifying && !hasCompleted && (
                <div>
                  <p>Se han encontrado <strong>{pendingTramites.length}</strong> trámites pendientes de verificación de SOAT.</p>
                  {pendingTramites.length > 0 ? (
                    <button 
                      className="btn-action" 
                      onClick={startVerification}
                      style={{ marginTop: '15px', background: 'var(--primary-color)', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', border: 'none', fontWeight: 'bold' }}
                    >
                      ▶️ Iniciar Verificación
                    </button>
                  ) : (
                    <p style={{ color: 'green', fontWeight: 'bold', marginTop: '15px' }}>¡Todo al día! No hay SOATs pendientes.</p>
                  )}
                </div>
              )}

              {verifying && (
                <div>
                  <p style={{ fontWeight: 'bold', fontSize: '18px', color: '#2563eb' }}>
                    Validando {currentIndex} / {pendingTramites.length} SOAT
                  </p>
                  <div style={{ width: '100%', backgroundColor: '#e5e7eb', borderRadius: '10px', height: '20px', margin: '20px 0', overflow: 'hidden' }}>
                    <div style={{ 
                      width: `${(currentIndex / pendingTramites.length) * 100}%`, 
                      backgroundColor: '#3b82f6', 
                      height: '100%', 
                      transition: 'width 0.3s ease' 
                    }}></div>
                  </div>
                </div>
              )}

              {hasCompleted && (
                <div>
                  <p style={{ color: '#16a34a', fontWeight: 'bold', fontSize: '18px' }}>✅ Proceso completado</p>
                  <p>Se actualizaron {results.length} SOATs a Vigente.</p>
                </div>
              )}

              {(verifying || hasCompleted) && results.length > 0 && (
                <div style={{ marginTop: '20px', textAlign: 'left', background: '#f8fafc', padding: '15px', borderRadius: '8px', maxHeight: '200px', overflowY: 'auto' }}>
                  <h4 style={{ marginBottom: '10px', fontSize: '14px', color: '#475569' }}>Placas actualizadas exitosamente:</h4>
                  <ul style={{ listStyleType: 'none', padding: 0, margin: 0, display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {results.map((r, idx) => (
                      <li key={idx} style={{ background: '#dcfce7', color: '#166534', padding: '4px 8px', borderRadius: '4px', fontSize: '13px', fontWeight: '600' }}>
                        {r.plate}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </>
          )}
        </div>

        {hasCompleted && (
          <div className="modal-footer" style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button className="btn-action" onClick={handleClose} style={{ background: '#3b82f6', color: 'white', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', border: 'none', fontWeight: 'bold' }}>
              Cerrar y Actualizar Bandeja
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificarSoatsModal;
